import { ZidWalletApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new ZidWalletApiService(ApiClientFactory());

export function ZidWalletApiServiceFactory(): typeof service {
  return service;
}
